import React from "react";

const Unauthorized = () => {
  return (
    <div>
      <h2>Unauthorized Access</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default Unauthorized;
